import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { ApplicationFacade } from '../store';
import { GENERIC_API_SERVICE, GENERIC_API_SOURCE } from '@core/data-access';

export const SKIP_AUTH_INTERCEPTOR = 'skip-auth-interceptor' as const;

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly facade = inject(ApplicationFacade);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    if (req.headers.get(GENERIC_API_SOURCE) !== GENERIC_API_SERVICE || req.headers.get(SKIP_AUTH_INTERCEPTOR) === 'true') {
      return next.handle(req);
    }

    if (!req.url.match('html2pdf')) return next.handle(req);

    return this.facade.accessToken$.pipe(
      switchMap(accessToken => {
        if (!accessToken) {
          return next.handle(req); // Continue without modification if no token
        }

        const clonedRequest = req.clone({
          setHeaders: { Authorization: `Bearer ${accessToken}` },
        });

        return next.handle(clonedRequest);
      }),
    );
  }
}
